import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CompaniesApiService } from 'features/companies';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { companiesQueryKeys } from './query-keys';

const { deleteCompanyImage } = CompaniesApiService();

export const useDeleteCompanyImage = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return deleteCompanyImage(id);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        console.error(uiMessage);
        message.error(i18n.t('companies.update.errorImageDelete'));
      },
      onSuccess: (data, id) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: companiesQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: companiesQueryKeys.detail(id),
          }),
        ]);
        message.success(i18n.t('companies.update.successfulImageDelete'));
      },
    },
  );
};
